import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import ImportFileModal from './ImportFileModal';
import { isLoading as isLoadingSelector, uploadedFile as uploadedFileSelector } from './ImportFileModalSelectors';

import ImportFileModalReducer from './ImportFileModalReducer';
import { importFileModalReducerKey } from './ImportFileModalConstants';
import { initialize, closeModal, importQuery, importRT, setUploadedFile, resetState } from './ImportFileModalActions';

/* eslint-disable no-shadow */

function ImportFileModalContainer(props) {
  const { isRt, importRt, importQuery, ...otherProps } = props;

  const importHandler = () => {
    if (isRt) {
      importRt();
    } else {
      importQuery();
    }
  };

  return <ImportFileModal {...otherProps} doImport={importHandler} isRt={isRt} />;
}

const mapStateToProps = (state) => ({
  isLoading: isLoadingSelector(state),
  uploadedFile: uploadedFileSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  initialize: (...args) => dispatch(initialize(...args)),
  close: () => dispatch(closeModal()),
  clearImport: () => dispatch(resetState()),
  importQuery: () => dispatch(importQuery()),
  importRt: () => dispatch(importRT()),
  importFile: (uploadedFile) => dispatch(setUploadedFile(uploadedFile)),
});

const EnhancedImportFileModalContainer = compose(
  withReducer(importFileModalReducerKey, ImportFileModalReducer),
  connect(mapStateToProps, mapDispatchToProps)
)(ImportFileModalContainer);

export default EnhancedImportFileModalContainer;
